import styled from 'styled-components'
import { BodyDefault, BodySmall, HeadLine1, HeadLine2 } from '../../../components/typography/styled'

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 30px 40px;

  @media (max-width: 760px) {
    padding: 10px 16px 30px;
  }
`

export const PageTitle = styled(HeadLine1)`
  color: ${({ theme }) => theme.palette[850]};
  margin: 0;
`

export const Navigation = styled.div`
  border-bottom: ${({ theme }) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  height: 42px;
  margin: 22px 0 10px;

  > div {
    position: absolute;
    bottom: -1px;
    left: 0;
  }
`

export const DetailHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-top: 8px;

  @media (max-width: 760px) {
    flex-direction: column;
  }
`

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 6px;
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

export const MutedText = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
  overflow-wrap: anywhere;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  box-sizing: border-box;
  padding: 20px;
  border: ${({ theme }) => `1px solid ${theme.grey[350]}`};
  border-radius: 8px;
  background: ${({ theme }) => theme.palette[20]};
`

export const CardTitle = styled(HeadLine2)`
  color: ${({ theme }) => theme.palette[850]};
  margin: 0;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`

export const FormActions = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
`

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
`

export const ToolbarGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`

export const PathTrail = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  min-width: 0;
`

export const PathPart = styled.button`
  border: 0;
  padding: 4px;
  color: ${({ theme }) => theme.palette[700]};
  background: transparent;
  cursor: pointer;
  font: inherit;

  &:hover {
    text-decoration: underline;
  }
`

export const ClickableName = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: 100%;
  border: 0;
  padding: 0;
  color: ${({ theme }) => theme.palette[800]};
  background: transparent;
  cursor: pointer;
  font: inherit;
  text-align: left;
  overflow-wrap: anywhere;

  &:hover {
    color: ${({ theme }) => theme.palette[700]};
  }
`

export const StatusBadge = styled(BodySmall)<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 3px 8px;
  border-radius: 12px;
  color: ${({ theme, $active }) => $active ? theme.success : theme.errors[600]};
  background: ${({ theme, $active }) => $active ? 'rgba(34, 155, 97, 0.12)' : theme.errors[100]};
`

export const JsonEditorWrapper = styled.div`
  min-width: 0;
  overflow: auto;
  border-radius: 6px;
`

export const JsonPreview = styled.pre`
  max-height: 55vh;
  margin: 0;
  padding: 14px;
  overflow: auto;
  border-radius: 6px;
  color: ${({ theme }) => theme.palette[800]};
  background: ${({ theme }) => theme.grey[300]};
  font-size: 12px;
  line-height: 1.5;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const SecretValue = styled.code`
  display: inline-block;
  max-width: 420px;
  overflow: hidden;
  color: ${({ theme }) => theme.palette[800]};
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const EmptyText = styled(BodyDefault)`
  color: ${({ theme }) => theme.grey[700]};
  padding: 12px 0;
`
